import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Stats from "@/pages/Stats";
import AdPreview from "@/pages/AdPreview";
import Privacy from "@/pages/Privacy";
import Support from "@/pages/Support";
import Redeem from "@/pages/Redeem";
import AdminCodes from "@/pages/AdminCodes";
import Golf from "@/pages/Golf";
import AdminGolf from "@/pages/AdminGolf";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/ad-preview" element={<AdPreview />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/redeem" element={<Redeem />} />
          <Route path="/admin/codes" element={<AdminCodes />} />
          <Route path="/farm-it-forward" element={<Golf />} />
          <Route path="/golf" element={<Golf />} />
          <Route path="/admin/farm-it-forward" element={<AdminGolf />} />
          <Route path="/admin/golf" element={<AdminGolf />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
